export enum EvaluationStatusEnum {
    InTolerance = 0,
    MidTolerance = 1,
    OutOfTolerance = 2,
    Unknown = 3
}